export const isValidValue = value => {
  if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
    return false
  }
  return value?.length > 0
}

export const addressedAtOptions = [
  {
    value: 'She/her/hers',
    label: 'She/her/hers',
  },
  {
    value: 'He/him/his',
    label: 'He/him/his',
  },
  {
    value: 'They/them/theirs',
    label: 'They/them/theirs',
  },
  {
    value: 'Ze/hir/hirs',
    label: 'Ze/Hir/Hirs',
  },
  {
    value: 'No pronoun',
    label: 'No Pronoun',
  },
  {
    value: 'No preference',
    label: 'No preference',
  },
  {
    value: 'Not listed',
    label: 'Not listed',
  },
  {
    value: 'I prefer not to say',
    label: 'I prefer not to say',
  },
]

export const thinkYourself = [
  {
    value: 'Straight or heterosexual',
    label: 'Straight or heterosexual',
  },
  {
    value: 'Lesbian, gay or homosexual',
    label: 'Lesbian, gay or homosexual',
  },
  {
    value: 'Bisexual',
    label: 'Bisexual',
  },
  {
    value: 'Pansexual',
    label: 'Pansexual',
  },
  {
    value: "Don't know",
    label: "Don't know",
  },
  {
    value: 'Choose not to disclose',
    label: 'Choose not to disclose',
  },
]

export const identity = [
  {
    value: 'Male',
    label: 'Male',
  },
  {
    value: 'Female',
    label: 'Female',
  },
  {
    value: 'Transgender male/Trans man/Female-to-Male (FTM)',
    label: 'Transgender male/Trans man/Female-to-Male (FTM)',
  },
  {
    value: 'Transgender Female/Trans woman/Male-to-Female (MTF)',
    label: 'Transgender Female/Trans woman/Male-to-Female (MTF)',
  },
  {
    value: 'Genderqueer, neither exclusively male nor female',
    label: 'Genderqueer, neither exclusively male nor female',
  },
  {
    value: 'Choose not to disclose',
    label: 'Choose not to disclose',
  },
]

export const genitalsOptions = [
  {
    value: 'male',
    label: 'Penis',
  },
  {
    value: 'female',
    label: 'Vagina',
  },
  {
    value: 'intersex',
    label: 'Intersex',
  },
]

export const sexOptions = [
  {
    value: 'male',
    label: 'Assigned male at birth',
  },
  {
    value: 'female',
    label: 'Assigned female at birth',
  }
]
